import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ZXingScannerModule } from "@zxing/ngx-scanner";
import { DLMSharedModule } from "app/views/calibrations/shared/shared.module";

@Component({
  selector: "part-location-qr-scan-dialog",
  templateUrl: "./bin-qr-scan-dialog.component.html",
  styleUrls: ["./bin-qr-scan-dialog.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    DLMSharedModule,
    ZXingScannerModule,
  ]
})
export class PartLocationQrScanDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PartLocationQrScanDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
  }

  scanSuccessHandler(data: string) {
    if(!data.startsWith('nexus-part-location-'))
      return;

    var binCode = data.split('nexus-part-location-')[1].trim();
    this.close(binCode);
  }

  close(result: string) {
    this.dialogRef.close(result);
  }
}
